export default {
  props: {
    section: {
      type: Object,
      default: () => {
      }
    },
    pageData: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    getSectionJSON () {
      return this.section?.raw_json?.['admin-section']
    },
    getSectionId () {
      return this.getSectionJSON?.id
    },
    hasSectionTitle () {
      return this.getSectionTitle
    },
    getSectionTitle () {
      return this.section.title || this.pageData?.data?.title
    },
    hasSectionContent () {
      return this.getSectionContent
    },
    getSectionContent () {
      return this.section.content
    },
    getSectionImage () {
      return this.section.image
    },
    hasSectionImage () {
      return !!this.getSectionImage
    }

  }
}
